import React from 'react';
import { Container } from '@hvcgroep/design-system';

const Error: React.FC = () => {
  return (
    <Container fluid>
      <h1>Error</h1>
    </Container>
  );
};

export default Error;
